import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";

import config from "../../config";
import { getAuthToken } from "../../utils/authStorage";
import { cancelButtonSx } from "./hpcAdminStatusStyles";

const HpcDeleteMemberDialog = ({ member, onClose, onDeleted }) => {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      const token = getAuthToken();
      await axios.delete(
        `${config.apiBaseUrl}/hpc/admin/registrations/${member.membership_id}`,
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );
      toast.success("Member deleted. Payment and attendance history were kept.");
      onDeleted();
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to delete member");
      onClose();
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Dialog open={Boolean(member)} onClose={() => !deleting && onClose()} fullWidth maxWidth="sm">
      <DialogTitle>Delete Member</DialogTitle>
      <DialogContent>
        {member && (
          <Typography variant="body2">
            Delete {member.full_name} ({member.membership_id})? The member will be removed from the
            member list, but their payment, receipt and attendance history is kept for records.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button variant="outlined" onClick={onClose} disabled={deleting} sx={cancelButtonSx}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={handleDelete} disabled={deleting}>
          {deleting ? "Deleting..." : "Delete Member"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HpcDeleteMemberDialog;
